import React, { FC, useEffect } from 'react';

import { Box } from '@mui/material';

import { ILogsUserData } from '@pharmaplan/common';

import ActivityLogUserItem from './ActivityLogUserItem';

import styles from './styles';
import { useAppDispatch } from '../../../../hooks/useAppDispatch';
import { setFooterShow } from '../../../../actions/drawerActions';

interface IActivityLogUsers {
  users: Array<ILogsUserData>;
}

const ActivityLogUsers: FC<IActivityLogUsers> = ({ users }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setFooterShow(false));
  }, []);

  return (
    <Box sx={styles.container}>
      {users.map((user) =>
        (
          <ActivityLogUserItem key={user.userId} user={user} />
        ))}
    </Box>
  );
};

export default ActivityLogUsers;
